import { ageLabel, domainLabel, enrollmentTypeLabel, formatLabel, teacherLabel } from '@sayyesschool/frontend/features/packs';
import { IconButton, Table } from '@sayyesschool/frontend/ui-components';

const columns = [
    { key: 'age', content: 'Возраст' },
    { key: 'domain', content: 'Направление' },
    { key: 'format', content: 'Формат' },
    { key: 'enrollmentType', content: 'Тип обучения' },
    { key: 'teacherType', content: 'Тип преподавателя' },
    { key: 'numberOfLessons', content: 'Кол-во уроков', numeric: true },
    { key: 'lessonDuration', content: 'Прод-ть урока, мин.', numeric: true },
    { key: 'lessonPrice', content: 'Стоимость урока, руб.', numeric: true },
    { key: 'packPrice', content: 'Стоимость пакета, руб.', numeric: true },
    { key: 'description', content: 'Описание' },
    { key: 'actions' }
];

export default function PacksTable({ packs, onEdit, onDelete }) {
    return (
        <Table className="PacksTable">
            <Table.Head>
                <Table.Row header>
                    {columns.map(col =>
                        <Table.Cell
                            key={col.key}
                            content={col.content}
                            header
                        />
                    )}
                </Table.Row>
            </Table.Head>

            <Table.Body>
                {packs.map(pack =>
                    <Table.Row key={pack.id}>
                        <Table.Cell
                            content={ageLabel[pack.age]}
                        />

                        <Table.Cell
                            content={domainLabel[pack.domain]}
                        />

                        <Table.Cell
                            content={formatLabel[pack.format]}
                        />

                        <Table.Cell
                            content={enrollmentTypeLabel[pack.enrollmentType]}
                        />

                        <Table.Cell
                            content={teacherLabel[pack.teacherType]}
                        />

                        <Table.Cell
                            content={pack.numberOfLessons}
                        />

                        <Table.Cell
                            content={pack.lessonDuration}
                        />

                        <Table.Cell
                            content={pack.lessonPrice}
                        />

                        <Table.Cell
                            content={pack.price}
                        />

                        <Table.Cell
                            content={pack.description}
                        />

                        <Table.Cell>
                            <IconButton.Group
                                buttons={[
                                    {
                                        key: 'edit',
                                        icon: 'edit',
                                        title: 'Изменить',
                                        onClick: () => onEdit(pack)
                                    },
                                    {
                                        key: 'delete',
                                        icon: 'delete',
                                        color: 'danger',
                                        title: 'Удалить',
                                        onClick: () => onDelete(pack)
                                    }
                                ]}
                                color="neutral"
                                size="sm"
                                variant="plain"
                            />
                        </Table.Cell>
                    </Table.Row>
                )}
            </Table.Body>
        </Table>
    );
}